import { render, staticRenderFns } from "./flat-icon-button.vue?vue&type=template&id=0ca26456"
import script from "./flat-icon-button.vue?vue&type=script&lang=js"
export * from "./flat-icon-button.vue?vue&type=script&lang=js"
import style0 from "./flat-icon-button.vue?vue&type=style&index=0&id=0ca26456&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports